import { useEffect, useState } from "react";
import { FormikProvider, useFormik } from "formik";
import { DetailsImageVehicleRow } from "../../fields-upload/DetailsImageVehicleRow";
import { IMaintenanceVisualRecord } from "../../../../../../types/maintenance-visual-record.type";
import { brDateHourFormat } from "../../../../../../common/helpers/date.helpers";

type NewType = {
  data: IMaintenanceVisualRecord;
  onClose?: () => void;
};

type VehicleEndMaintenanceDetailsProps = NewType;
export default function VehicleEndMaintenanceDetails(
  props: VehicleEndMaintenanceDetailsProps
) {
  const [vehicleId, setvehicleId] = useState<string | null>(null);

  const formik = useFormik({
    initialValues: {
      endMaintenance: props.data.photosMaintenance[0].endMaintenance,
    },
    onSubmit: (values) => {
      values;
    },
  });

  useEffect(() => {
    if (props.data !== undefined) {
      props.data && setvehicleId(vehicleId);
    }
  }, [props.data, vehicleId]);

  return (
    <div className="fixed inset-0 z-10 bg-black bg-opacity-30 flex justify-center items-center p-4">
      <FormikProvider value={formik}>
        <section
          style={{ backgroundColor: "rgb(179, 175, 175)" }}
          className=" flex flex-col items-center rounded-md shadow-lg min-w-[40%] max-w-[90%] md:max-w-2xl mx-auto p-4 max-h-[calc(100vh-4rem)] overflow-auto"
        >
          <h2 className="text-2xl font-semibold mb-4">Detalhes da devolução</h2>
          <div className="flex flex-wrap justify-center">
            {formik.values?.endMaintenance?.map((doc, index) => (
              <div
                key={index}
                className={`flex flex-col space-y-2 p-3 my-0 rounded ${
                  index % 2 ? "bg-gray/5" : "bg-gray/5"
                }`}
              >
                <DetailsImageVehicleRow
                  name={`endMaintenance.${index}`}
                  initialData={doc || {}}
                  prefix="end-maintenance"
                  vehicleId={props.data.vehicleId}
                />
              </div>
            ))}
          </div>
          <div className="w-full sm:w-[70%] h-auto min-h-[200px] p-2 rounded-md shadow-lg mb-8 bg-white/50 text-black overflow-auto">
            <p className="font-bold">
              `Tipo de Manutenção: {props.data.typeMaintenance}`
            </p>

            <p className="font-bold">Peças alteradas: </p>
            {props.data.budgetlabel.map((piece) => (
              <div key={piece._id} className="mb-2">
                <span className="font-semibold">{piece.name}</span>, Quantidade:{" "}
                {piece.quantity}, Tipo: {piece.type}, Preço unitário:{" "}
                {piece.price}
              </div>
            ))}
            <p className="font-bold">Mecânico Responsável:</p>
            <p>{props.data.mechanic}</p>
            <p className="font-bold">Hodômetro do Veículo:</p>
            <p>{props.data?.odometer}Km</p>
          </div>
          <div className="w-full sm:w-[70%] h-auto min-h-[200px] p-2 rounded-md shadow-lg mb-8 bg-white/50 text-black overflow-auto">
            <p className="font-bold">Observações: </p>
            {props.data.maintenanceObservation
              ?.slice()
              .reverse()
              .map((observation, index) => (
                <div
                  key={index}
                  className="w-full bg-gray/10 my-4 p-2 rounded-md border border-gray/40"
                >
                  <label className="font-semibold">
                    {brDateHourFormat(observation.date)}
                  </label>
                  <p className="whitespace-pre-wrap">
                    <h3 className="font-semibold">Observação:</h3>
                    {observation.text}
                  </p>
                  <br />
                  <p className="font-semibold">
                    Criado por: {observation.author}
                  </p>
                </div>
              ))}
          </div>
          <button
            onClick={props.onClose}
            className="bg-redPrimary text-white w-24 border-black border-opacity-30 shadow-md relative self-end"
          >
            Fechar
          </button>
        </section>
      </FormikProvider>
    </div>
  );
}
